import { withTeams } from 'hocs';

import { TeamsSelect as TeamsSelectImpl } from '../components/teamsSelect';

export const TeamsSelect = withTeams(TeamsSelectImpl, { pageSize: 25 });
